import { render, staticRenderFns } from "./CotizacionesComponent.vue?vue&type=template&id=2078b14c&"
import script from "./CotizacionesComponent.vue?vue&type=script&lang=js&"
export * from "./CotizacionesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports